import React, { useState } from 'react';
import Sysc3Attestation from '../components/security/Sysc3Attestation';
import TcfMiReport from '../components/security/TcfMiReport';
import MtaRegister from '../components/security/MtaRegister';
import SystemHealth from '../components/security/SystemHealth';
import TrainingOverview from '../components/security/TrainingOverview';
import ChangeLog from '../components/security/ChangeLog';
import { securityAPI } from '../services/api';
import './SecurityCompliance.css';

type Tab = 'sysc3' | 'tcf' | 'mta' | 'health' | 'training' | 'changelog';

const TABS: { id: Tab; label: string }[] = [
  { id: 'sysc3',     label: 'SYSC 3 Attestation' },
  { id: 'tcf',       label: 'TCF MI Report' },
  { id: 'mta',       label: 'MTA Register' },
  { id: 'health',    label: 'System Health' },
  { id: 'training',  label: 'Training Overview' },
  { id: 'changelog', label: '📋 Version Log' },
];

const SecurityCompliance: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('sysc3');
  const [downloadingReport, setDownloadingReport] = useState(false);

  const handleDownloadComplianceReport = async () => {
    setDownloadingReport(true);
    try {
      const res = await securityAPI.downloadComplianceReportPdf();
      const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Myshield-Compliance-Actions-19May2026.pdf';
      link.click();
      URL.revokeObjectURL(url);
    } catch {
      alert('Failed to generate compliance report. Please try again.');
    } finally {
      setDownloadingReport(false);
    }
  };

  return (
    <div className="sc-page">
      <div className="sc-page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h2 className="sc-page-title">Security &amp; Compliance</h2>
          <p className="sc-page-subtitle">
            FCA regulatory attestations, TCF evidence, MTA notification register and system health monitoring.
          </p>
        </div>
        <button
          onClick={handleDownloadComplianceReport}
          disabled={downloadingReport}
          style={{
            background: '#001f3f', color: '#fff', border: 'none', borderRadius: 8,
            padding: '10px 18px', fontSize: 12, fontWeight: 700, cursor: 'pointer',
            letterSpacing: '0.5px', whiteSpace: 'nowrap', flexShrink: 0,
          }}
        >
          {downloadingReport ? 'Generating…' : '⬇ Compliance Report PDF'}
        </button>
      </div>

      <div className="sc-tab-bar">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`sc-tab-btn${activeTab === tab.id ? ' sc-tab-btn--active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="sc-tab-content">
        {activeTab === 'sysc3'     && <Sysc3Attestation />}
        {activeTab === 'tcf'       && <TcfMiReport />}
        {activeTab === 'mta'       && <MtaRegister />}
        {activeTab === 'health'    && <SystemHealth />}
        {activeTab === 'training'  && <TrainingOverview />}
        {activeTab === 'changelog' && <ChangeLog />}
      </div>
    </div>
  );
};

export default SecurityCompliance;
